import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { AbstractTuiControl } from '@taiga-ui/legacy';

@Component({
  selector: 'list-item-edit',
  templateUrl: './list-item-edit.component.html',
  styleUrls: ['./list-item-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListItemEditComponent extends AbstractTuiControl<string> {
  @Input() itemTitle?: string;

  @Output() itemTitleChange = new EventEmitter<string>();

  get focused(): boolean {
    return false;
  }

  protected getFallbackValue(): string {
    return '';
  }
}
